import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function arrayValidator(validOptions: (string | number)[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let isValid = false;
    const selectedValue = control.value;
    if (validOptions.includes(selectedValue)) {
      isValid = true;
    }
    if (Array.isArray(selectedValue)) {
      isValid = selectedValue.every((value) => validOptions.includes(value));
    }
    return isValid ? null : {invalidArrayValue: true};
  };
}
